module.exports = __webpack_public_path__ + "static/media/telegram_logo.fb9dc4b6.png";